exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 1024px){.mobile-only[data-v-46e1b79a]{display:none !important}}@media (max-width: 1023px){.desktop-only[data-v-46e1b79a]{display:none !important}}@media (min-width: 1024px){.o-footer[data-v-46e1b79a]{margin:auto}}.o-footer .sf-footer[data-v-46e1b79a]{--footer-width: auto}.o-footer .withdrawal-link[data-v-46e1b79a]{display:-ms-inline-flexbox;display:inline-flex;margin-top:4px;padding:0 6px;background-color:#ffba00;border-radius:3px;color:#2f2e3b}\n", ""]);

// exports
